<template>
  <!-- <div>
  <div class="page-content">-->
  <div class>
    <!-- <h1 class="content-heading fa fa-money">Make Payment</h1> -->
    <!-- <div class="widget-icon" style="margin-top: 36px">
      <span class="fa fa-ticket fa-3x"></span>
    </div> -->
    <!-- <h2 slot="title"></h2> -->
    <div class="row" v-show="transDone === false">
      <div class="col-12 creditCardForm">
        <div class="heading">
          <h3>Fund Wallet</h3>
        </div>
        <div class="payment">
          <div class="form-group owner" id="owner">
            <label for="owner">Owner</label>
            <b-form-input
              type="text"
              v-model="formData.name"
              placeholder="John Doe"
              class="form-control form-control-lg"
            />
          </div>
          <div class="form-group expiration-date" id="phone">
            <label for="mobile">Phone No</label>
            <b-form-input
              type="tel"
              v-model="formData.phonenumber"
              class="form-control form-control-lg cc-number"
              placeholder="08011111111"
              id="mobile"
            />
          </div>
          <div class="form-group cardno" id="email">
            <label for="email">Email</label>
            <b-form-input
              type="email"
              v-model="formData.email"
              class="form-control form-control-lg"
              placeholder="mymail@mail.com"
              id="email"
            />
          </div>
          <div class="form-group expiration-date" id="amount">
            <label for="amount">Amount</label>
            <b-form-input
              v-model="formData.amount"
              class="form-control form-control-lg"
              placeholder="20000.00"
              type="currency"
            />
          </div>
          <!-- <div class="form-group cardno" id="owner">
                        <label for="country">Country</label>
                        <b-form-select  v-model="formData.country"  :options="countries" id="country" placeholder="Nigeria" class="mb-3 form-control form-control-lg" style="height: 43px;padding-top: 3px;">
                </b-form-select>
          </div>-->

          <div class="form-group" style="width:100%; text-align: center;">
            <div class="App" style="display:none">
              <p class="App-intro">
                <Rave
                  :is-production="true"
                  :text="raveBtnText"
                  style-class="paymentbtn"
                  id="paymentbtn"
                  :email="formData.email"
                  :amount="formData.amount"
                  :reference="reference"
                  :rave-key="raveKey"
                  :callback="callback"
                  :close="close"
                  currency="NGN"
                  :customer_firstname="formData.firstname"
                  :customer_lastname="formData.lastname"
                  :customer_phone="formData.phonenumber"
                ></Rave>
                <!-- :customer_firstname="formData.firstname"
                :customer_lastname="formData.lastname"
                :custom_logo="custom_logo"
                :custom_description="custom_description"
                :custom_title= "this.custom_title"-->
              </p>
            </div>
            <button
              type="button"
              class="btn btn-default"
              style="width:40%; background-color: #ffb946;"
              @click="confirmPayment"
            >Proceed</button>
          </div>
        </div>
      </div>
    </div>
    <div class="row" v-show="transDone === true">
      <div class="widget_box" v-show="transComplete === true">
        <figcaption>
          <p>
            Transaction Completed with Reference ID:
            <b
              v-if="myResponse"
            >{{ myResponse.detail.flwref }}</b>
          </p>
          <div>
            Comfirm your transaction details below:
            <p v-if="myResponse">
              <b>Full Name</b>
              {{myResponse.detail.custname}}
            </p>
            <p v-if="myResponse">
              <b>Transaction Medium</b>
              {{myResponse.detail.paymenttype}}
            </p>
            <p v-if="myResponse">
              <b>Amount</b>
              {{myResponse.detail.amount}}
            </p>
            <p v-if="myResponse">
              <b>Charged Amount</b>
              {{myResponse.detail.chargedamount}}
            </p>
          </div>
          <b-btn to="/home" variant="info">
            <span class="sidebar-collapse-text">Done</span>
          </b-btn>
        </figcaption>
      </div>
      <div class="widget_box" v-show="transComplete === false">
        <figcaption>Transaction in Progress ...</figcaption>
      </div>
    </div>
  </div>
  <!-- </div>
  </div>-->
</template>

<script>
/* eslint-disable */

import Vue from "vue";
import Autocomplete from "v-autocomplete";
import ItemTemplate from "../../utils/ItemTemplate.vue";
import Fingerprint2 from "fingerprintjs2";
import payform from "payform";
import Rave from "vue-ravepayment";
Vue.use(Autocomplete);
import { mapGetters } from "vuex";
import { stringify } from "querystring";
export default {
  name: "generate-token",
  components: {
    Rave
  },
  data() {
    return {
      transComplete: false,
      transDone: false,
      cardno: null,
      cvv: null,
      expiry: null,
      pin: null,
      // raveKey: "FLWPUBK-1e55a9d76566528730de3cadb478beb9-X",
      raveKey: "FLWPUBK-fc3e5bbcb014dba6aea1724614daa1d5-X",
      raveBtnText: "Make Payment",
      formData: {
        expirymonth: "00",
        expiryyear: "00",
        email: "",
        name: null,
        firstname: "John",
        lastname: "Doe",
        phonenumber: null,
        amount: 10000,
        deviceFingerprint: "00000",
        //   country: "NG",
        //   currency: "NGN",
        device_fingerprint: {
          components: null,
          result: null
        }
      },
      otp: "",
      currentDevice: null,
      myResponse: null,
      countries: [
        {
          value: null,
          text: "Please select an option",
          disabled: true
        },
        {
          value: "NG",
          text: "Nigeria"
        }
      ],
      currency: [
        {
          value: null,
          text: "Please select an option",
          disabled: true
        },
        {
          value: "NGN",
          text: "Naria"
        }
      ],
      items: [],
      errors: null,
      template: ItemTemplate
    };
  },
  notifications: {
    showSuccessMsg: {
      type: "success",
      title: "Success",
      message: "Success Msg!"
    },
    showInfoMsg: {
      type: "info",
      title: "Information",
      message: "Info. Msg!"
    },
    showWarnMsg: {
      type: "warning",
      title: "Warning",
      message: "Warning Msg!"
    },
    showErrorMsg: {
      type: "error",
      title: "Error",
      message: "Error Msg!"
    }
  },
  methods: {
    callback: function(response) {
      let trRef = response.data;
      trRef.data = trRef.tx == undefined ? trRef.data : trRef.tx;
      if (trRef.data.status === "successful") {
        this.transDone = true;
      } else
        this.showErrorMsg({
          message: "Transaction fails"
        });
      this.transComplete = this.concludeTransaction(trRef.data.txRef);
      this.close;
    },
    close: function() {
      console.log("Payment closed");
    },
    concludeTransaction(txRef) {
      var data = true;
      var str = JSON.stringify({
        txref: txRef
      });
      const tempReg = JSON.parse(str);
      const HTTP = this.$httpUtils.instance;
      const url = "/payments/flutterwave/";
      HTTP.post(url, tempReg)
        .then(response => {
          this.myResponse = response.data.data[0];
          console.log(response.data.data[0]);
          data = true;
        })
        .catch(error => {
          console.log(error);
          var errorMsg = error.response.data.message;
          this.showErrorMsg({
            message: errorMsg
          });
          data = false;
        });
      return data;
    },
    confirmPayment() {
      this.validateReg(this.formData);
      var container = this;
      var errorLength = Object.keys(this.errors).length;
      if (errorLength > 0) {
        this.errorMessage = "Fill All FIelds!!!";
        this.displayError = true;
        setTimeout(() => {
          this.displayError = false;
        }, 3000);
        var errorMsg = Object.values(this.errors).join("<br>");
        this.showErrorMsg({
          message: errorMsg
        });
      } else {
        var fp = Fingerprint2();
        fp.get(function(result, components) {
          container.formData.deviceFingerprint = result; // a hash, representing your device fingerprint
          container.formData.device_fingerprint.components = components; // an array of FP components
        });
        [
          container.formData.firstname,
          container.formData.lastname
        ] = container.formData.name.split(" ");
        document.getElementById("paymentbtn").click();
      }
    },
    finishGeneration() {
      this.$router.push({
        path: "/home"
      });
    },
    validateReg(data) {
      let err = [];
      for (let [field, value] of Object.entries(data)) {
        value = value + "";
        if (value !== "null" && value !== Number.isInteger(value)) {
          value = value.trim();
        }
        if (value === "null" || value === "") {
          err[field] = `Please select a ${field}.`;
        } else if (field == "email" && !this.isEmail(value)) {
          err[field] = "Not a valid email.";
        }
      }
      this.errors = err;
      // console.log(this.errors);
    },
    loader() {
      this.formData.name = `${this.getUserSession.firstName} ${
        this.getUserSession.lastName
      }`;
      this.formData.phonenumber = `${this.getUserSession.phoneNumber}`;
      this.formData.email = `${this.getUserSession.email}`;
    },
    isEmail(email) {
      var re = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
      return re.test(email.toLowerCase());
    },
    updateItems(text) {
      this.items = this.returnData(text);
    },
    hideModal() {
      this.$refs.myModalRef.hide();
    },
    showModal() {
      this.$refs.myModalRef.show();
    }
  },
  mounted() {
    this.loader();
  },
  computed: {
    ...mapGetters(["getUserSession"]),
    reference() {
      let text = "";
      let possible =
        "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789";
      for (let i = 0; i < 5; i++)
        text += possible.charAt(Math.floor(Math.random() * possible.length));
      text += Math.round(new Date().getTime() / 1000);
      return text;
    }
  }
};
</script>

<style>
* {
  margin: 0;
  padding: 0;
  box-sizing: border-box;
}

body {
  font: normal 18px sans-serif;
  color: #333;
  background-color: #eee;
}

.container-fluid {
  padding: 0;
  margin: 0;
}

.creditCardForm {
  /* max-width: 700px; */
  background-color: #fff;
  margin: 10px auto;
  overflow: hidden;
  padding: 25px;
  color: #4c4e56;
}

.creditCardForm label {
  width: 100%;
  margin-bottom: 10px;
}

.container h1,
.container h4 {
  text-align: center;
  font-family: "Open Sans", sans-serif;
  color: #4c4e56;
}

.container h1 {
  padding: 20px;
}

.creditCardForm .payment {
  float: left;
  font-size: 18px;
  /* padding: 10px 25px; */
  margin-top: 20px;
  position: relative;
}

.creditCardForm .payment .form-group {
  float: left;
  margin-bottom: 15px;
}

.form-control {
  line-height: 40px;
  height: auto;
  padding: 0 16px;
}

.creditCardForm .owner {
  width: 63%;
  margin-right: 10px;
}

.creditCardForm .CVV {
  width: 35%;
}

.creditCardForm #card-number-field {
  width: 100%;
}

.creditCardForm .expiration-date {
  width: 35%;
}

.creditCardForm .cardno {
  width: 63%;
  margin-right: 10px;
}

.creditCardForm #pay-now {
  width: 100%;
  margin-top: 25px;
}

.creditCardForm .payment .btn-default {
  margin-top: 3px;
  font-size: 24px;
  background-color: #2ec4a5;
  color: white;
}

.creditCardForm .payment select {
  padding: 10px;
  margin-right: 15px;
}

.creditCardForm .payment .cardtype {
  float: right;
  margin-top: 20px;
}

.transparent {
  opacity: 0.2;
}

b {
  font-weight: 900;
}

.widget-icon {
  text-align: center;
}

span.fa-ticket {
  color: #2ec4a5;
  border: 1px solid #fff;
  border-radius: 50%;
  margin-bottom: 8px;
  line-height: 80px;
  width: 80px;
  height: 80px;
}

/* .widget {
  box-shadow: 0 4px 70px -18px rgba(0, 0, 0, 0.2);
} */

@media (max-width: 650px) {
  .creditCardForm .owner,
  .creditCardForm .CVV,
  .creditCardForm #expiration-date,
  .creditCardForm #credit_cards,
  .creditCardForm #owner,
  .creditCardForm #phone,
  .creditCardForm #email,
  .creditCardForm #amount {
    width: 100%;
  }

  .creditCardForm #credit_cards {
    text-align: left;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/pages/shs/ravepay.vue